import { useEffect, useState } from 'react';
import api from '../../api/axios';
import StatusBadge from '../../components/StatusBadge';

const CM = {
  pending:     { bg: 'linear-gradient(135deg,#f59e0b,#fbbf24)', shadow: 'rgba(245,158,11,0.3)' },
  approved:    { bg: 'linear-gradient(135deg,#0d1a6e,#4f6ef7)', shadow: 'rgba(79,110,247,0.3)' },
  rejected:    { bg: 'linear-gradient(135deg,#dc2626,#ef4444)', shadow: 'rgba(220,38,38,0.3)' },
  in_progress: { bg: 'linear-gradient(135deg,#ea580c,#f97316)', shadow: 'rgba(234,88,12,0.3)' },
  completed:   { bg: 'linear-gradient(135deg,#7c3aed,#a78bfa)', shadow: 'rgba(124,58,237,0.3)' },
};

const AdminDashboard = () => {
  const [stats, setStats] = useState([]);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get('/requests/stats').then(r => setStats(r.data));
    api.get('/users').then(r => setUsers(r.data));
  }, []);

  return (
    <div>
      {/* Banner */}
      <div style={S.banner}>
        <div style={S.bannerBg} />
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={S.bannerTitle}>Admin Dashboard</div>
          <div style={S.bannerSub}>System-wide overview and user management</div>
        </div>
        <div style={S.blob} />
      </div>

      {/* Stats */}
      <div style={S.statsRow}>
        {stats.map(s => {
          const c = CM[s.status] || { bg: 'linear-gradient(135deg,#64748b,#94a3b8)', shadow: 'rgba(0,0,0,0.2)' };
          return (
            <div key={s.status} style={{ ...S.statCard, background: c.bg, boxShadow: `0 8px 24px ${c.shadow}` }}>
              <div style={S.statValue}>{s.count}</div>
              <div style={S.statLabel}>{s.status.replace('_', ' ').toUpperCase()}</div>
            </div>
          );
        })}
      </div>

      {/* Users table */}
      <div style={S.card}>
        <div style={S.cardTop}>
          <div style={S.cardTitle}>Recent Users</div>
          <div style={S.badge}>{users.length} total</div>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={S.table}>
            <thead>
              <tr style={S.thead}>
                {['Name', 'Email', 'Role', 'Joined'].map(h => (
                  <th key={h} style={S.th}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {users.slice(0, 10).map((u, i) => (
                <tr key={u.id} style={{ ...S.tr, background: i % 2 === 0 ? '#fff' : '#f8faff' }}>
                  <td style={{ ...S.td, fontWeight: 700, color: '#0B1554' }}>{u.name}</td>
                  <td style={S.td}>{u.email}</td>
                  <td style={S.td}><StatusBadge status={u.role} /></td>
                  <td style={{ ...S.td, color: '#94a3b8' }}>{new Date(u.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const S = {
  banner: {
    background: 'linear-gradient(135deg,#060d3a 0%,#0d1a6e 50%,#2d0a5a 100%)',
    borderRadius: 18, marginBottom: 28, padding: '32px 36px',
    position: 'relative', overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(6,13,58,0.25)',
  },
  bannerBg: { position: 'absolute', inset: 0, background: 'radial-gradient(ellipse at 80% 50%,rgba(172,65,104,0.2) 0%,transparent 60%)' },
  bannerTitle: { color: '#fff', fontSize: 24, fontWeight: 800, marginBottom: 8, letterSpacing: -0.3 },
  bannerSub: { color: 'rgba(255,255,255,0.6)', fontSize: 14 },
  blob: { position: 'absolute', width: 200, height: 200, borderRadius: '50%', background: 'rgba(172,65,104,0.12)', top: -80, right: 60, filter: 'blur(30px)' },
  statsRow: { display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 28 },
  statCard: { borderRadius: 16, padding: '22px 28px', minWidth: 150, flex: 1 },
  statValue: { fontSize: 38, fontWeight: 900, color: '#fff', lineHeight: 1, letterSpacing: -1 },
  statLabel: { fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.7)', marginTop: 8, letterSpacing: 1, textTransform: 'uppercase' },
  card: { background: '#fff', borderRadius: 18, boxShadow: '0 4px 20px rgba(11,21,84,0.06)', overflow: 'hidden', border: '1px solid rgba(79,110,247,0.06)' },
  cardTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: '1px solid #f1f5f9' },
  cardTitle: { fontSize: 14, fontWeight: 800, color: '#0B1554' },
  badge: { background: '#f0f4ff', color: '#4f6ef7', fontSize: 12, fontWeight: 700, padding: '4px 12px', borderRadius: 20 },
  table: { width: '100%', borderCollapse: 'collapse' },
  thead: { background: 'linear-gradient(135deg,#060d3a,#0d1a6e)' },
  th: { padding: '13px 18px', color: '#F7D506', textAlign: 'left', fontSize: 11, fontWeight: 700, letterSpacing: 0.8 },
  tr: { borderBottom: '1px solid #f1f5f9' },
  td: { padding: '13px 18px', fontSize: 13.5, color: '#374151' },
};

export default AdminDashboard;
